import { Pressable, View } from "react-native"
import BFText, { type BFTextVariantType } from "../standard/BFText"

type TextTabSizes = "sm" | "md" | "lg"

export interface TextTabProps {
  label: string
  value: string
  selected?: boolean
  disabled?: boolean
  isDimmed?: boolean
  dark?: boolean
  badge?: number
  size?: TextTabSizes
  onSelect: (value: string) => void
}

const SIZE_VARIANT: Record<TextTabSizes, BFTextVariantType> = {
  sm: "H5",
  md: "H4",
  lg: "H3",
}

export const TextTab = ({
  label,
  value,
  selected,
  disabled,
  badge,
  onSelect,
  size = "lg",
  isDimmed = false,
  dark = false,
}: TextTabProps) => (
  <Pressable
    className="flex flex-row justify-center flex-1"
    onPress={
      disabled
        ? () => {}
        : () => {
            onSelect(value)
          }
    }
    testID={`tab-${value}`}
  >
    <View
      className={`pb-1 flex-1 px-0 justify-center items-center border-b-2 ${selected ? (dark ? "border-teal" : "border-calm-blue") : "border-transparent"}`}
    >
      <BFText
        variant={SIZE_VARIANT[size]}
        className={
          isDimmed
            ? "text-dark-grey"
            : dark
              ? selected
                ? "text-teal"
                : disabled
                  ? "text-calm-blue"
                  : "text-white"
              : selected
                ? "text-calm-blue"
                : disabled
                  ? "text-light-grey"
                  : "text-midnight-blue"
        }
      >
        {label}
      </BFText>
    </View>
    {!!badge && (
      <View className="flex justify-center items-center bg-neon-yellow h-[14px] mt-1 ml-2 rounded-[10px]">
        <BFText className="font-spacegrotesk text-midnight-blue text-[10px] px-[6px]">
          {badge}
        </BFText>
      </View>
    )}
  </Pressable>
)

export interface TabsProps {
  className?: string
  children: any
  hasFullWidthLine?: boolean
}

export default function TextTabs({
  children,
  className,
  hasFullWidthLine = true,
}: TabsProps) {
  return (
    <View className="relative">
      {hasFullWidthLine && (
        <View
          className={`absolute top-[30px] -inset-x-1/2 h-px bg-off-white opacity-20`}
        />
      )}
      <View
        className={`flex flex-row items-end justify-stretch mt-2 ${className || ""}`}
      >
        {children}
      </View>
    </View>
  )
}
